/**
 * Quick Actions Card Component - Atalhos Rápidos
 * Displays quick action buttons for common tasks
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import { Zap, Plus, Archive, BookOpen } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export const QuickActionsCard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Card className="card-navy-glass border-navy-500">
      <CardHeader className="border-b border-navy-500">
        <CardTitle className="text-foreground flex items-center gap-2">
          <Zap className="w-5 h-5 text-primary" />
          Atalhos Rápidos
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Button
            className="h-auto py-6 gradient-primary-br hover:opacity-90 text-white shadow-accent border-0"
            onClick={() => navigate("/processes/new")}
          >
            <div className="flex flex-col items-center gap-2">
              <Plus className="w-8 h-8" />
              <span className="font-semibold text-lg">Novo Processo</span>
              <span className="text-xs opacity-90">Iniciar licitação</span>
            </div>
          </Button>

          <div className="relative overflow-hidden">
            <div className="absolute top-2 -right-8 z-10 w-32 text-center transform rotate-45 bg-gradient-to-r from-blue-600 to-blue-500 text-white text-xs font-semibold py-1 pl-4 shadow-lg">
               Em breve
            </div>
            <Button
              className="h-auto py-6 bg-licitars-warning/20 border-2 border-licitars-warning text-licitars-warning hover:bg-licitars-warning/30 hover:border-licitars-warning shadow-lg w-full opacity-60 cursor-not-allowed"
              disabled
            >
              <div className="flex flex-col items-center gap-2">
                <Archive className="w-8 h-8" />
                <span className="font-semibold text-lg">Arquivo</span>
                <span className="text-xs opacity-90">Processos finalizados</span>
              </div>
            </Button>
          </div>

          <div className="relative overflow-hidden">
            <div className="absolute top-2 -right-8 z-10 w-32 text-center transform rotate-45 bg-gradient-to-r from-blue-600 to-blue-500 text-white text-xs font-semibold py-1 pl-4 shadow-lg">
              Em breve
            </div>
            <Button
              className="h-auto py-6 bg-emerald-500/20 border-2 border-emerald-500 text-emerald-400 hover:bg-emerald-500/30 hover:border-emerald-400 hover:text-emerald-300 shadow-lg w-full opacity-60 cursor-not-allowed"
              disabled
            >
              <div className="flex flex-col items-center gap-2">
                <BookOpen className="w-8 h-8" />
                <span className="font-semibold text-lg">Base Legal</span>
                <span className="text-xs opacity-90">Leis e decretos</span>
              </div>
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
